import React, { useState, useEffect } from "react";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

import { Typography, Grid, Paper, IconButton, Button } from "@material-ui/core";
import Loading from "./Loading";

import { withStyles } from "@material-ui/styles";
import styles from "./Styles/BookScreenStyles";
import API from "../Services/API";
import { duration } from "moment";

var daysOffSet = 1;
var nextSlots = "true";
var localDate = new Date();
var apptDate = localDate.getMonth() + 1 + "/" + localDate.getDate() + "/" + localDate.getFullYear();
var nextMonth, nextDate, nextYear, prevMonth, prevDate, prevYear;
var futureDate = new Date(localDate);
futureDate.setMonth(futureDate.getMonth() + 3);
var prevSlotButton = "";
var curSlotButton = "";
var prevSlotDayHeader = "";
var curSlotDayHeader = "";

const BookScreen = (props) => {
  let { classes } = props;

  const [didInitLoad, setDidInitLoad] = useState(false);
  const [prevSlotsIcon, setPrevSlotsIcon] = useState(false);
  const [nextSlotsIcon, setNextSlotsIcon] = useState(true);
  const [noData, setNoData] = useState("");
  const [loading, setLoading] = useState(false);
  const [paperWidth, setPaperWidth] = useState("");
  const [paperHeight, setPaperHeight] = useState("");
  const [totalSlots, setTotalSlots] = useState("");
  const [dayOneSlots, setDayOneSlots] = useState("");
  const [dayTwoSlots, setDayTwoSlots] = useState("");
  const [dayThreeSlots, setDayThreeSlots] = useState("");
  const [dayFourSlots, setDayFourSlots] = useState("");
  const [dayFiveSlots, setDayFiveSlots] = useState("");

  const api = API.create();
  useEffect(() => {
    if (props.changeScreen.newCall) {
      setDidInitLoad(false);
      props.changeScreen.newCall = false;
    }
    window.addEventListener("scroll", scrollFunction);
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      setPaperWidth("100%");
      setPaperHeight("100%");
    } else {
      setPaperWidth("90%");
      setPaperHeight("90%");
    }

    if (!didInitLoad) {
      initialLoad();
    }
    return () => {
      window.removeEventListener("scroll", scrollFunction);
    };
  }, [props.changeScreen.newCall]);

  const scrollFunction = () => {
    try {
      var paperHeader = document.getElementById("paperTop");
      var headerElement = document.getElementById("slotHeader");
      if (paperHeader != "null" || paperHeader != null) {
        if (window.pageYOffset > paperHeader.offsetTop) {
          headerElement.style.width = paperHeader.offsetWidth + "px";
          headerElement.classList.add(classes.sticky);
        } else {
          headerElement.classList.remove(classes.sticky);
        }
      }
    } catch (e) { }
  };

  const initialLoad = () => {
    setLoading(true);
    callFreeSlotsAPI(props.changeScreen.selectedProvider.split("@")[0]);
    setDidInitLoad(true);
  };

  var callFreeSlotsAPI = (schResourceId) => {
    setDayOneSlots("");
    setDayTwoSlots("");
    setDayThreeSlots("");
    setDayFourSlots("");
    setDayFiveSlots("");
    var params = {
      dbname: props.changeScreen.dbname,
      providerId: schResourceId,
      forQuickBook: true,
      daysLimit: "5",
      daysOffSet: daysOffSet,
      apptDate: apptDate,
      nextSlots: nextSlots,
      duration: props.changeScreen.selectedApptType?.includes("New Patient -") ? "60" : ""
    };
    if (props.changeScreen.selectedLocation !== undefined && props.changeScreen.selectedLocation !== null && props.changeScreen.selectedLocation !== "") {
      var locId = parseInt(props.changeScreen.selectedLocation, 10);
      if (!isNaN(locId)) {
        params.selectedLocation = locId;
      }
    }
    api.getFreeSlots(
      params,
      (res) => {
        if (res.status === 200) {
          setNoData("false");
          let resObj = res.data;
          setTotalSlots(resObj);
          if (resObj && Array.isArray(resObj) && resObj.length > 0) {
            setNoData("false");
            for (var i = 0; i < resObj.length; i++) {
              if (i === 0) {
                setDayOneSlots(resObj[i].freeSlots);
                prevMonth = resObj[i].monthValue;
                prevDate = Number(resObj[i].date) - 1;
                prevYear = resObj[i].year;
              } else if (i === 1) setDayTwoSlots(resObj[i].freeSlots);
              else if (i === 2) setDayThreeSlots(resObj[i].freeSlots);
              else if (i === 3) setDayFourSlots(resObj[i].freeSlots);
              else if (i === 4) {
                setDayFiveSlots(resObj[i].freeSlots);
                nextMonth = resObj[i].monthValue;
                nextDate = Number(resObj[i].date) + 1;
                nextYear = resObj[i].year;
              }
            }
            if (daysOffSet == 1) {
              setPrevSlotsIcon(true);
            } else {
              setPrevSlotsIcon(false);
            }
            const apptDateObj = new Date(nextYear, nextMonth - 1, nextDate);
            if (apptDateObj >= futureDate) {
              setNextSlotsIcon(true);
            } else {
              setNextSlotsIcon(false);
            }
          } else {
            setNoData("true");
          }
        } else {
          setNoData("true");
        }
        setLoading(false);
      }
    );
  };
  var loadPrevSlots = () => {
    nextSlots = "false";
    daysOffSet = daysOffSet - 1;
    apptDate = prevMonth + "/" + prevDate + "/" + prevYear;
    callFreeSlotsAPI(props.changeScreen.selectedProvider.split("@")[0]);
  };

  var loadNextSlots = () => {
    nextSlots = "true";
    daysOffSet = daysOffSet + 1;
    apptDate = nextMonth + "/" + nextDate + "/" + nextYear;
    callFreeSlotsAPI(props.changeScreen.selectedProvider.split("@")[0]);
  };

  var handleSlotClick = (id) => {
    if (curSlotButton === null || curSlotButton === "null") prevSlotButton = "";
    else prevSlotButton = curSlotButton;
    curSlotButton = id;

    prevSlotDayHeader = curSlotDayHeader;
    curSlotDayHeader =
      document.getElementById(curSlotButton).getAttribute("slotyear") +
      "-" +
      document.getElementById(curSlotButton).getAttribute("slotmonthvalue") +
      "-" +
      document.getElementById(curSlotButton).getAttribute("slotdate");

    var selectedStartTime =
      curSlotDayHeader +
      " " +
      document
        .getElementById(curSlotButton)
        .getAttribute("starttime")
        .toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        }) +
      ":00";

    var selectedEndTime =
      curSlotDayHeader +
      " " +
      document
        .getElementById(curSlotButton)
        .getAttribute("endtime")
        .toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        }) +
      ":00";

    var slotInterval = document
      .getElementById(curSlotButton)
      .getAttribute("interval");

    if (prevSlotButton != "") {
      document.getElementById(prevSlotButton).style.backgroundColor = "white";
      document.getElementById(prevSlotButton).style.color =
        "rgba(0, 0, 0, 0.87)";
    }
    document.getElementById(curSlotButton).style.backgroundColor =
      "rgb(68, 68, 68)";
    document.getElementById(curSlotButton).style.color = "white";

    if (prevSlotDayHeader != "") {
      document.getElementById(prevSlotDayHeader).style.border = "none";
      document.getElementById(prevSlotDayHeader).style.backgroundColor =
        "white";
    }
    document.getElementById(curSlotDayHeader).style.border =
      "1px solid rgb(25, 26, 27)";
    document.getElementById(curSlotDayHeader).style.backgroundColor =
      "rgb(237, 237, 237)";
    continueInfo(
      curSlotDayHeader,
      selectedStartTime,
      selectedEndTime,
      slotInterval
    );
  };

  var continueInfo = (date, st, et, it) => {
    props.changeScreen.continueToInfo(
      props.changeScreen.dbname,
      date,
      st,
      et,
      it
    );
  };

  var convertTheTime = (time) => {
    var time = time.toString().split(":")[0].length > 1 ? time : "0" + time;
    var time =
      time.toString().split(":")[1].length > 1
        ? time
        : time.toString().split(":")[0] + ":0" + time.toString().split(":")[1];
    var time =
      time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || time;
    if (time.length > 1) {
      time = time.slice(1);
      time[5] = +time[0] < 12 ? " AM" : " PM";
      time[0] = +time[0] % 12 || 12;
    }
    return time.join("");
  };

  return (
    <div>
      {loading && <Loading />}
      {!loading && (
        <div>
          {noData === "true" && (
            <div className={classes.noData}>No free slots available.</div>
          )}
          {noData === "false" && (
            <Grid>
              <Typography className={classes.heading1}>
                Select available timing
              </Typography>
              <Paper
                id="paperTop"
                square
                variant="outlined"
                className={classes.paper}
                style={{
                  padding: 0,
                }}
              >
                <Grid
                  id="slotHeader"
                  container
                  style={{ textAlign: "center", backgroundColor: "#f9f9f9" }}
                >
                  <Grid item xs={1} className={classes.centerContent}>
                    <IconButton
                      disabled={prevSlotsIcon}
                      onClick={loadPrevSlots.bind(null)}
                    >
                      <NavigateBeforeIcon />
                    </IconButton>
                  </Grid>
                  {Object.keys(totalSlots).map((key, index) => (
                    <Grid
                      item
                      xs={2}
                      id={[
                        totalSlots[key].year,
                        totalSlots[key].monthValue,
                        totalSlots[key].date,
                      ].join("-")}
                      className={classes.slotDayHeader}
                    >
                      <Grid item>
                        <Typography>{totalSlots[key].day}</Typography>
                      </Grid>
                      <Grid item>
                        <Typography>
                          {totalSlots[key].month} {totalSlots[key].date}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                  <Grid item xs={1} className={classes.centerContent}>
                    <IconButton onClick={loadNextSlots.bind(null)}
                      disabled={nextSlotsIcon}
                    >
                      <NavigateNextIcon />
                    </IconButton>
                  </Grid>
                </Grid>
                <Grid
                  container
                  style={{
                    textAlign: "center",
                    marginTop: "3%",
                    justifyContent: "center",
                  }}
                >
                  <Grid item xs={12}></Grid>
                  <Grid
                    item
                    xs={2}
                    style={{ textAlign: "center", justifyContent: "center" }}
                  >
                    <Grid item xs={12}>
                      {Object.keys(dayOneSlots).map((key, index) => (
                        <Grid item xs={12} style={{ padding: "8%" }}>
                          <Button
                            variant="outlined"
                            className={classes.slotButton}
                            id={[
                              totalSlots[0]?.year,
                              totalSlots[0]?.monthValue,
                              totalSlots[0]?.date,
                              index,
                            ].join("-")}
                            starttime={dayOneSlots[key].startTime}
                            endtime={dayOneSlots[key].endTime}
                            interval={dayOneSlots[key].interval}
                            slotyear={totalSlots[0]?.year}
                            slotmonthvalue={totalSlots[0]?.monthValue}
                            slotdate={totalSlots[0]?.date}
                            onClick={handleSlotClick.bind(
                              null,
                              [
                                totalSlots[0]?.year,
                                totalSlots[0]?.monthValue,
                                totalSlots[0]?.date,
                                index,
                              ].join("-")
                            )}
                          >
                            <Typography style={{ fontSize: "14px" }}>
                              {convertTheTime(dayOneSlots[key].startTime)}
                            </Typography>
                          </Button>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                  <Grid item xs={2} style={{ textAlign: "center" }}>
                    <Grid item xs={12}>
                      {Object.keys(dayTwoSlots).map((key, index) => (
                        <Grid item xs={12} style={{ padding: "8%" }}>
                          <Button
                            variant="outlined"
                            className={classes.slotButton}
                            id={[
                              totalSlots[1]?.year,
                              totalSlots[1]?.monthValue,
                              totalSlots[1]?.date,
                              index,
                            ].join("-")}
                            starttime={dayTwoSlots[key].startTime}
                            endtime={dayTwoSlots[key].endTime}
                            interval={dayTwoSlots[key].interval}
                            slotyear={totalSlots[1]?.year}
                            slotmonthvalue={totalSlots[1]?.monthValue}
                            slotdate={totalSlots[1]?.date}
                            onClick={handleSlotClick.bind(
                              null,
                              [
                                totalSlots[1]?.year,
                                totalSlots[1]?.monthValue,
                                totalSlots[1]?.date,
                                index,
                              ].join("-")
                            )}
                          >
                            <Typography style={{ fontSize: "14px" }}>
                              {convertTheTime(dayTwoSlots[key].startTime)}
                            </Typography>
                          </Button>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                  <Grid item xs={2} style={{ textAlign: "center" }}>
                    <Grid item xs={12}>
                      {Object.keys(dayThreeSlots).map((key, index) => (
                        <Grid item xs={12} style={{ padding: "8%" }}>
                          <Button
                            variant="outlined"
                            className={classes.slotButton}
                            id={[
                              totalSlots[2]?.year,
                              totalSlots[2]?.monthValue,
                              totalSlots[2]?.date,
                              index,
                            ].join("-")}
                            starttime={dayThreeSlots[key].startTime}
                            endtime={dayThreeSlots[key].endTime}
                            interval={dayThreeSlots[key].interval}
                            slotyear={totalSlots[2]?.year}
                            slotmonthvalue={totalSlots[2]?.monthValue}
                            slotdate={totalSlots[2]?.date}
                            onClick={handleSlotClick.bind(
                              null,
                              [
                                totalSlots[2]?.year,
                                totalSlots[2]?.monthValue,
                                totalSlots[2]?.date,
                                index,
                              ].join("-")
                            )}
                          >
                            <Typography style={{ fontSize: "14px" }}>
                              {convertTheTime(dayThreeSlots[key].startTime)}
                            </Typography>
                          </Button>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>

                  <Grid item xs={2} style={{ textAlign: "center" }}>
                    <Grid item xs={12}>
                      {Object.keys(dayFourSlots).map((key, index) => (
                        <Grid item xs={12} style={{ padding: "8%" }}>
                          <Button
                            variant="outlined"
                            className={classes.slotButton}
                            id={[
                              totalSlots[3]?.year,
                              totalSlots[3]?.monthValue,
                              totalSlots[3]?.date,
                              index,
                            ].join("-")}
                            starttime={dayFourSlots[key].startTime}
                            endtime={dayFourSlots[key].endTime}
                            interval={dayFourSlots[key].interval}
                            slotyear={totalSlots[3]?.year}
                            slotmonthvalue={totalSlots[3]?.monthValue}
                            slotdate={totalSlots[3]?.date}
                            onClick={handleSlotClick.bind(
                              null,
                              [
                                totalSlots[3]?.year,
                                totalSlots[3]?.monthValue,
                                totalSlots[3]?.date,
                                index,
                              ].join("-")
                            )}
                          >
                            <Typography style={{ fontSize: "14px" }}>
                              {convertTheTime(dayFourSlots[key].startTime)}
                            </Typography>
                          </Button>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                  <Grid item xs={2} style={{ textAlign: "center" }}>
                    <Grid item xs={12}>
                      {Object.keys(dayFiveSlots).map((key, index) => (
                        <Grid item xs={12} style={{ padding: "8%" }}>
                          <Button
                            variant="outlined"
                            className={classes.slotButton}
                            id={[
                              totalSlots[4]?.year,
                              totalSlots[4]?.monthValue,
                              totalSlots[4]?.date,
                              index,
                            ].join("-")}
                            starttime={dayFiveSlots[key].startTime}
                            endtime={dayFiveSlots[key].endTime}
                            interval={dayFiveSlots[key].interval}
                            slotyear={totalSlots[4]?.year}
                            slotmonthvalue={totalSlots[4]?.monthValue}
                            slotdate={totalSlots[4]?.date}
                            onClick={handleSlotClick.bind(
                              null,
                              [
                                totalSlots[4]?.year,
                                totalSlots[4]?.monthValue,
                                totalSlots[4]?.date,
                                index,
                              ].join("-")
                            )}
                          >
                            <Typography style={{ fontSize: "14px" }}>
                              {convertTheTime(dayFiveSlots[key].startTime)}
                            </Typography>
                          </Button>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          )}
        </div>
      )}
    </div>
  );
};

export default withStyles(styles)(BookScreen);